import { render, staticRenderFns } from "./TaxReturnEditModal.vue?vue&type=template&id=445b3304&scoped=true&"
import script from "./TaxReturnEditModal.vue?vue&type=script&lang=js&"
export * from "./TaxReturnEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnEditModal.vue?vue&type=style&index=0&id=445b3304&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b3304",
  null
  
)

export default component.exports